module.exports = __webpack_public_path__ + "img/avatar-user.b125eae4.png";